module.exports = __webpack_public_path__ + "assets/images/premium-features/noshow-90ab4c.png";